//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/TaggedObjectList.js";
import "../no/Expression.js";
import "../no/ObjectList.js";
let d=[[[0,"CableDirection",1,"Direction",0],[0,"ConductorCount",1,0],[1,"ConductorSpacing",0,"Expression",0],[1,"ConductorWidth",0,"Expression",0],[1,"CrossSectionWidth",0,"Expression",0],[1,"SegmentList",0,"TaggedObjectList",0],[0,"StartPoint",1,"Point",0],[1,"StrippingLength",0,"Expression",0],[1,"Thickness",0,"Expression",0],[0,"ThicknessDirection",1,"Direction",0]],[[["flexibleCableSegment"],"GetIndexOfSegment",{R_:{index:''}},1,0],[["index"],"GetSegment",{R_:{flexibleCableSegment:"Features.SheetMetal.FlexibleCableSegment"}},1,0],[["index"],"DeleteSegment",{},1,0],[[],"DeleteAllSegments",{},0,0],[["length","segmentIndex"],"CreatePlanarSegment",{R_:{planarSegment:"Features.SheetMetal.FlexibleCableSegment"}},2,0],[["bendAngle","bendRadius","pathAdjustmentAngle","bendAngleDirection","pathAdjustmentAngleDirection","segmentIndex"],"CreateBendSegment",{R_:{bendSegment:"Features.SheetMetal.FlexibleCableSegment"}},6,0],[[],"GetSegmentCount",{R_:{segmentCount:''}},0,0]],[]];
SPLM.Features.SheetMetal.FlexibleCableBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlexibleCableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.FlexibleCableBuilder.BendAngleDirectionOptions = Object.freeze({
    "ReverseNormalDirection" : "ReverseNormalDirection", "NormalDirection" : "NormalDirection"});

SPLM.Features.SheetMetal.FlexibleCableBuilder.PathAdjustmentAngleDirectionOptions = Object.freeze({
    "LeftDirection" : "LeftDirection", "RightDirection" : "RightDirection"});

SPLM.Features.SheetMetal.FlexibleCableBuilder.SegmentTypeOptions = Object.freeze({
    "Planar" : "Planar", "Bend" : "Bend"});

export default SPLM;